/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} My_Grower_Report_MonthInputs */

const vi_my_grower_report_month = /** @type {(inputs: My_Grower_Report_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tháng ${i?.month}`)
};

/**

* @param {My_Grower_Report_MonthInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_month = /** @type {((inputs: My_Grower_Report_MonthInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_MonthInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_month(inputs)
});